import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { EmptyState } from "@/components/shared/empty-state";
import { KudosCard } from "@/features/kudos/kudos-card";
import { CreateKudosDialog } from "@/features/kudos/create-kudos-dialog";
import { useKudosForObjective, useKudosForKeyResult } from "@/hooks/use-kudos";
import { useCurrentUser, isSupervisorOrAbove } from "@/hooks/use-current-user";

interface KudosListProps {
  objectiveId?: string;
  krId?: string;
}

export function KudosList({ objectiveId, krId }: KudosListProps) {
  const { currentUser } = useCurrentUser();
  const objectiveKudos = useKudosForObjective(objectiveId ?? "");
  const krKudos = useKudosForKeyResult(krId ?? "");

  const query = objectiveId ? objectiveKudos : krKudos;
  const canGiveKudos = isSupervisorOrAbove(currentUser?.role);

  return (
    <Card>
      <CardHeader>
        <div className="flex items-center justify-between">
          <CardTitle>Kudos</CardTitle>
          {canGiveKudos && (
            <CreateKudosDialog objectiveId={objectiveId} krId={krId} />
          )}
        </div>
      </CardHeader>
      <CardContent>
        {query.isLoading ? (
          <div className="space-y-3">
            <Skeleton className="h-12 w-full" />
            <Skeleton className="h-12 w-full" />
          </div>
        ) : !query.data?.data || query.data.data.length === 0 ? (
          <EmptyState
            title="No Kudos Yet"
            description={
              canGiveKudos
                ? "Recognize great work by giving kudos."
                : "Kudos from supervisors will appear here."
            }
          />
        ) : (
          <div className="space-y-3">
            {query.data.data.map((k) => (
              <KudosCard key={k.id} kudos={k} />
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
